import { render, staticRenderFns } from "./GiftCardPurchase.vue?vue&type=template&id=22ad8483&"
import script from "./GiftCardPurchase.vue?vue&type=script&lang=js&"
export * from "./GiftCardPurchase.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardPurchase.vue?vue&type=style&index=0&id=22ad8483&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports